import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '../environments/environment';

export const authConfig: AuthConfig = {
  issuer: environment.SSO.stsServer,
  loginUrl: environment.SSO.stsServer + '/connect/authorize',
  logoutUrl: environment.SSO.stsServer + '/Account/logout',
  redirectUri: `${environment.URL_Front}connected`,
  clientId: 'b2ff66c9-593f-44c4-b6e3-0a2d5576ce6b_ClientTestGlnRegistry',
  scope: 'accesGlnRegistry',
  oidc : true,
  customQueryParams:{
    'companies':true,
    'prompt':'login'
  },
  userinfoEndpoint : environment.SSO.stsServer + '/connect/userinfo',
  tokenEndpoint : environment.SSO.stsServer + '/connect/token',
  requestAccessToken: true,
  showDebugInformation: true,
  postLogoutRedirectUri: `${environment.URL_Front}`,
  useSilentRefresh: true,
  silentRefreshRedirectUri: window.location.origin + '/assets/static-pages/silent-refresh.html',
  useIdTokenHintForSilentRefresh: true
};
